import { useEffect, useRef } from 'react';
import useIntersectionObserver from '@/utils/hooks/utils/useIntersectionObserver';
import Loader from '@/components/base/Loader';

const LoadMoreInfinite = ({ loadMore, isLoadingMore }) => {
    const loadMoreButtonRef = useRef();
    const loadMoreInViewPort = useIntersectionObserver(loadMoreButtonRef, '0px');

    useEffect(() => {
        if (!isLoadingMore && loadMoreInViewPort) {
            loadMore();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoadingMore, loadMoreInViewPort]);

    return (
        <div
            ref={loadMoreButtonRef}
            className="flex w-full justify-center pb-3 text-center text-icoGray-400">
            <Loader className="ml-3 h-4 w-4 text-icoGray-400 dark:text-icoDarkMode-wolf" />
        </div>
    );
};

export default LoadMoreInfinite;
